import { Box, Grid } from '@material-ui/core';
import React, { FunctionComponent, useCallback } from 'react';
import { IPrice } from '../../../../../../../../common/model/IPrice';
import useIsMobile from '../../../../../../common/react/useIsMobile';
import PriceWithLabel from '../../../../customiseContainer/footer/PriceSection/CarPrices/PriceWithLabel/PriceWithLabel';
import singleCurrencyStyles from './singleCurrencyStyles';
import IndicativeNumber from '../../../../../../common/components/indicativeNumber/IndicativeNumber';
import useScrollToSection from '../../../../../react/navigation/useScrollToSection';
import { CustomiseSections } from '../../../../../../common/enum/CustomiseSections';
import { ScrollInViewBehaviourType } from '../../../../../../common/service/scrollInView';
import CalculateButton from '../../../financeElements/calculateButton/CalculateButton';
import Translation from '../../../../../../common/components/translation/Translation';

export interface IFinanceSingleCurrency {
  disabled?: boolean;
  loading?: boolean;
  paymentValue: IPrice;
  paymentFrequency: string;
  shouldDisplayFinance: boolean;
  onFinanceCalculate: () => void;
  // @TODO: Find a better flag for this.
  hasComparisonRate: boolean;
  decimalScale: number;
}

const SingleCurrency: FunctionComponent<IFinanceSingleCurrency> = ({
  disabled,
  loading,
  paymentValue,
  paymentFrequency,
  shouldDisplayFinance,
  onFinanceCalculate,
  hasComparisonRate,
  decimalScale,
}) => {
  const isMobile = useIsMobile();
  const styles = singleCurrencyStyles();
  const { scrollToSection } = useScrollToSection();
  const onFinanceClick = useCallback(() => {
    scrollToSection(CustomiseSections.DISCLAIMER, ScrollInViewBehaviourType.SMOOTH);
  }, []);

  if (!shouldDisplayFinance) {
    return (
      <Grid item={true} xs={6}>
        <CalculateButton disabled={disabled} onFinanceCalculate={onFinanceCalculate} />
      </Grid>
    );
  }

  return (
    <Box
      display="flex"
      flexDirection={isMobile ? 'column' : 'row'}
      alignItems={'center'}
      justifyContent={'flex-start'}
      width={1}
      data-test={'finance_values:price:payment_value'}
    >
      <PriceWithLabel
        price={{
          basePrice: paymentValue?.basePrice ?? 0,
          currency: paymentValue?.currency,
        }}
        decimalScale={decimalScale}
        // @TODO: Move this logic up, pass only the value to this component and add as translation
        label={
          <>
            {hasComparisonRate ? paymentFrequency : <Translation id={'spc.customise.repayment'} />}
            <IndicativeNumber
              dataTest="repayment"
              displayNumber={<Translation id="spc.customise.indicative.repayment" />}
              onClick={onFinanceClick}
            />
          </>
        }
        loading={loading}
      />
      <Box className={styles.priceWithButtonSectionItem}>
        <CalculateButton disabled={disabled} onFinanceCalculate={onFinanceCalculate} />
      </Box>
    </Box>
  );
};

export default SingleCurrency;
